import { Component, Input } from "@angular/core";
import { CommentObj } from "../../interfaces/comment-obj";



@Component({
    selector: 'app-card-review',
    templateUrl: './card-review.component.html',
    styleUrls: ['./card-review.component.scss'],

})

export class CardReviewComponent {
    @Input() comment: CommentObj;
    constructor() {
        this.comment = {} as CommentObj;
    }
 }

